import React from "react";
import { Space, Tooltip } from "antd";
import ZohoLogo from "../../images/logos/zoho_crm.png";
import logoStripe from "./images/stripe.png";
import ParseLogo from "./images/parse.png";
import JiraLogo from "./images/jira.png";
import config from "../../api_config.json";
import { useAppContext } from "../../context";

const sizes = {
  small: 20,
  large: 30,
};

const linkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '6px',
  backgroundColor: 'transparent',
  transition: 'all 0.2s ease',
  textDecoration: 'none',
};

const ServiceLink = ({ href, tooltip, logo, size, brandColor }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Tooltip title={tooltip} placement="top">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        style={{
          ...linkStyle,
          backgroundColor: isHovered ? `${brandColor}10` : 'transparent',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img 
          src={logo} 
          width={sizes[size]} 
          alt={tooltip} 
          style={{ 
            display: 'block',
            filter: isHovered ? 'brightness(1.1)' : 'brightness(1)',
            transition: 'filter 0.2s ease',
          }} 
        />
      </a>
    </Tooltip>
  );
};

const OrgLinks = (props) => {
  const { isProd } = useAppContext();
  const { org, size = "small", style } = props;

  if (org.nome) {
    const zohoCrmUrl = `https://crm.zoho.eu/crm/org20108764695/search?searchword=${encodeURIComponent(org.objectId)}&isRelevance=false`;

    return (
      <Space direction="horizontal" size={4} style={style}>
        <ServiceLink
          href={zohoCrmUrl}
          tooltip="Cerca in Zoho CRM"
          logo={ZohoLogo}
          size={size}
          brandColor="#ff7a59"
        />
        
        <ServiceLink
          href={`${config.parseDashboard[isProd ? "prod" : "dev"]}/browser/organizzazione?filters=[{"field":"objectId","constraint":"eq","compareTo":"${org.objectId}"}]`}
          tooltip="Visualizza in Parse Dashboard"
          logo={ParseLogo}
          size={size}
          brandColor="#169cee"
        />
        
        {org.jira_id && (
          <ServiceLink
            href={`https://onoranzefunebricloud.atlassian.net/jira/servicedesk/projects/SC/organizations/${org.jira_id}`}
            tooltip="Visualizza in Jira Service Desk"
            logo={JiraLogo}
            size={size}
            brandColor="#0052cc"
          />
        )}
        
        {org.stripe_customer_id && (
          <ServiceLink
            href={`https://dashboard.stripe.com/customers/${org.stripe_customer_id}`}
            tooltip="Visualizza in Stripe"
            logo={logoStripe}
            size={size}
            brandColor="#635bff"
          />
        )}
      </Space>
    );
  }

  if (org.email) {
    return (
      <Space direction="horizontal" size={4} style={style}>
        <ServiceLink
          href={`https://crm.zoho.eu/crm/org20108764695/search?searchword=${encodeURIComponent(org.objectId)}&isRelevance=false`}
          tooltip="Cerca in Zoho CRM"
          logo={ZohoLogo}
          size={size}
          brandColor="#ff7a59"
        />
        
        <ServiceLink
          href={`${config.parseDashboard[isProd ? "prod" : "dev"]}/browser/organizzazione?filters=[{"field":"objectId","constraint":"eq","compareTo":"${org.objectId}"}]`}
          tooltip="Visualizza in Parse Dashboard"
          logo={ParseLogo}
          size={size}
          brandColor="#169cee"
        />
      </Space>
    );
  }

  return <></>;
};

export default OrgLinks;
